import {runPostTypesConfigSync} from "../../postTypes";

const menus = {
    homeMenu: "Home",
    aboutMenu: "About",
    ...runPostTypesConfigSync({action:"getConstants", rKey:"menus"}).reduce((a, v) => {return {...a, ...v}}, {})
};

export default menus;
